const themeColor = process.env.NEXT_PUBLIC_THEME_COLOR || '#356AC7';

export default themeColor;
